export default function RadioSelector({
    options = [],
    name = "catgory1",
    selectedKey = "All",
    fetchDataForSelectedOption,
}) {
    // Render whenever there is at least the default "All" option so the category
    // bar stays consistent across every sport. Previously (> 1) a sport with no
    // extra leagues showed no bar at all, unlike the sports that do.
    if (options.length > 0) {
        return (
            <div className='catgoryListPartComponent'>
                <ul>
                    {options.map((option) => (
                        <li
                            className='fs13'
                            key={option.key || option.title}
                            onClick={async () => await fetchDataForSelectedOption(option)}
                        >
                            <input
                                id={`id-${option.key || option.title}`}
                                type="radio"
                                name={name}
                                checked={(option.key || option.title) === selectedKey}
                                readOnly
                            />
                            <label htmlFor={`id-${option.key || option.title}`}>
                                {option.title}
                            </label>
                        </li>
                    ))}
                </ul>

            </div>
        );
    } else {
        return <></>
    }

}